var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNodata(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 36,
    viewBox: "0 0 57 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_870_13613)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.4287 35.0913C43.8295 35.0913 56.3144 32.3805 56.3144 29.0366C56.3144 25.6927 43.8295 22.9819 28.4287 22.9819C13.0278 22.9819 0.542969 25.6927 0.542969 29.0366C0.542969 32.3805 13.0278 35.0913 28.4287 35.0913Z",
    fill: "#CED2DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4724 12.4012L39.6309 2.45244C39.2065 1.77431 38.5869 1.36432 37.9342 1.36432H18.9249C18.2722 1.36432 17.6526 1.77431 17.2282 2.45157L8.38672 12.4021V20.3934H48.4724V12.4012Z",
    stroke: "#9EA5B8",
    strokeWidth: 0.871428
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8066 15.144C36.8066 13.7557 37.6728 12.6096 38.7473 12.6088H48.4724V28.2965C48.4724 30.1328 47.3221 31.6379 45.9017 31.6379H10.9574C9.537 31.6379 8.38672 30.132 8.38672 28.2965V12.6088H18.1119C19.1863 12.6088 20.0525 13.7531 20.0525 15.1414V15.1604C20.0525 16.5487 20.9283 17.6696 22.0019 17.6696H34.8572C35.9308 17.6696 36.8066 16.5383 36.8066 15.15V15.144Z",
    fill: "#F9FAFC",
    stroke: "#9EA5B8",
    strokeWidth: 0.871428
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_870_13613"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55.7714,
    height: 34.8571,
    fill: "white",
    transform: "translate(0.542969 0.49292)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodata);
export default __webpack_public_path__ + "static/media/nodata.e37f656da4fc67bdde9f1608548649a0.svg";
export { ForwardRef as ReactComponent };